<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
// import theme from "@/components/layout/common/theme.js";
export default {
  name: "App",
  mounted() {
    // var my_color = localStorage.getItem("color");
    // var theme_color = this.$store.state.settings.theme;
    // if (my_color) theme.setColor(my_color);
    // else theme.setColor(theme_color);
  },
};
</script>
<style>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type="number"] {
  -moz-appearance: textfield;
}
</style>
